<template>
<div class="detail">
  <div class="info">
    <div class="info-img" @click="goodDetailHandle">
      <img class="spu-img" v-show="dataInfo.url" v-lazy="dataInfo.url" alt="" width="50px" height="50px">
      <img src="~@/assets/img/bitmap.png" v-show="!dataInfo.url" alt="" width="50px" height="50px">
      <div class="good-label" v-show="dataInfo.lable"></div>
      <div class="good-label-text" v-show="dataInfo.lable">{{dataInfo.lable}}</div>
    </div>
    <div class="good-info ellipsis">
      <div class="ellipsis detailname" @click="goodDetailHandle">{{dataInfo.name}}</div>
      <div class="multi_line_overflow info-model">{{$t('stockInquiry.specification')}}：{{dataInfo.norms}}</div>
    </div>
  </div>
  <div class="subsidiary">
    <div class="s2b-row">
      <div class="s2b-label">
        <img src="@/assets/img/infoBrand.png" alt="" class="icon-img">
        {{$t('common.brand')}}：
      </div>
      <div class="s2b-content ellipsis">
        {{dataInfo.brand}}
      </div>
    </div>
    <div class="s2b-row">
      <div class="s2b-label">
        <img src="@/assets/img/infoType.png" alt="" class="icon-img">
        {{$t('common.sku')}}：
      </div>
      <div class="s2b-content">
        {{dataInfo.type}}
      </div>
    </div>
  </div>
</div>
  <!-- <div class="info">
    <div class="info-main">
      <div class="img">
        <img v-lazy="dataInfo.url" alt="" class="img">
        <div class="good-label">精选</div>
      </div>
      <div class="name-list mw2">
        <div class="row ellipsisMaxWidth">
          {{dataInfo.name}}
        </div>
        <div class="row ellipsisMaxWidth3">
          规格型号：{{dataInfo.norms}}
        </div>
      </div>
    </div>
    <div class="info-context">
      <div class="row">
        <img src="@/assets/img/infoBrand.png" alt="" class="icon-img"><span class="label">品牌：</span>{{dataInfo.brand}}
      </div>
      <div class="row">
        <img src="@/assets/img/infoType.png" alt="" class="icon-img"><span class="label">编码：</span>{{dataInfo.type}}
      </div>
    </div>
  </div> -->
</template>

<script>
import { openOther } from '@/utils'

export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {
          url: '', // 图片
          name: '', // 名称
          norms: '', // 规格
          brand: '', // 品牌
          type: '', // 型号
          lable: '' // 标签
        }
      }
    }
  },
  created () {
    // console.log(this.dataInfo)
  },
  methods: {
    // 跳转共享备件详情
    goodDetailHandle () {
      console.log(this.dataInfo)
      if (!this.dataInfo.spuId) {
        return false
      }
      openOther(`sparePartsLibraryGoodDetail?spuId=${this.dataInfo.spuId}&skuId=${this.dataInfo.skuId}&custspId=${this.dataInfo.custspId}`)
      // &defaultCompany=${this.$store.state.user.defaultCompanyId}
    }
  }
}
</script>

<style lang="scss" scoped>
.detail{
  padding: 3px 5px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 22px;
  color: #333;
  .info{
    flex-grow: 1;
    display: flex;
    margin-right: 20px;
    max-width: 100%;
    overflow: hidden;
    .info-img{
      width: 50px;
      position: relative;
      margin-right: 10px;
      cursor: pointer;
      .spu-img {
        object-fit: contain;
      }
      .good-label {
        position: absolute;
        border: 15px solid #ffff99;
        top: 0;
        left: 0;
        height: 0;
        width: 0;
        border-right-color: transparent;
        border-bottom-color: transparent;
      }
      .good-label-text{
        position: absolute;
        color: #fff;
        font-weight: bold;
        left: -5px;
        top: -5px;
        transform:rotate(-45deg);
        -ms-transform:rotate(-45deg);
        -moz-transform:rotate(-45deg);
        -webkit-transform:rotate(-45deg);
        -o-transform:rotate(-45deg);
      }
    }
    .good-info{
      flex-grow: 1;
      font-weight: 500;
      .info-model{
        max-height: 66px;
        -webkit-line-clamp: 3;
        word-break: break-all;
        word-wrap: break-word;
        white-space: pre-wrap;
        // line-height: ;
      }
    }
  }
  .subsidiary{
    width: 36%;
    flex-shrink: 0;
  }
  .s2b-row{
    display: flex;
    .s2b-label{
      flex-shrink: 0;
      color: #999999;
    }
    .s2b-content{}
  }
}
.info {
  display: flex;
  .info-main {
    flex: 2;
    margin-right: 10px;
    .img {
      position: absolute;
      width: 40px;
      height: 40px;
    }
    .good-label {
      position: absolute;
      border: 10px solid #e6686e;
      height: 0;
      width: 0;
      border-right-color: transparent;
      border-bottom-color: transparent;
      // color: rgb(95, 28, 204);
      // text-align: center;
      // text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;
      // -webkit-transform: rotate(-45deg);
      // transform: rotate(-45deg);
      // -ms-transform: rotate(-45deg);
      // -o-transform: rotate(-45deg);
      // position: absolute;
      // padding: 10px 0;
      // left: 1px;
      // top: -1px;
      // font-size: 12px;
    }
    // .good-label{
    //   // color: ;
    //   position: absolute;
    //   left: -5px;
    //   top: -5px;
    //   transform:rotate(-45deg);
    //   -ms-transform:rotate(-45deg);
    //   -moz-transform:rotate(-45deg);
    //   -webkit-transform:rotate(-45deg);
    //   -o-transform:rotate(-45deg);
    // }
    .name-list {
      margin-left: 50px;
      color: #333;
      font-weight: bold;
      display: inline-block;
      vertical-align: top;
    }
  }
  .info-context {
    flex: 1;
    color: #333;
    .label {
      color: #999;
    }
    .icon-img {
      vertical-align: top;
      width: 14px;
      height: 14px;
    }
  }
  .row {
    line-height: 16px;
    margin-bottom: 6px;
  }
  .mw2 {
    max-width: 200px;
  }
  .ellipsisMaxWidth {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .ellipsisMaxWidth3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
.detailname{
  display: inline;
  cursor: pointer;
  color: #1d65a8;
  &:hover{
    text-decoration: underline;
  }
}
</style>
